import get from 'immutable-less/transmute/get';
import { Map as ImmutableMap, List } from 'immutable';
import OutputTypeDefinition from 'automation-ui-flow-core/fields/OutputTypeDefinition';
import OutputFieldKeys from 'automation-ui-action-features/action-outputs/records/OutputFieldKeys';
import { UPDATE } from 'automation-ui-action-features/actions/custom-code/constants/updateTypes';
import OutputField from 'automation-ui-action-features/action-outputs/records/OutputField';
export const _mapOutputFieldDefinitionsToOutputFields = outputFieldDefinitions => {
  return outputFieldDefinitions.map(outputFieldDefinition => {
    return new OutputField({
      // @ts-expect-error inner value of OutputFieldDefinition_1 is incorrectly typed as unknown
      [OutputFieldKeys.OUTPUT_FIELD_DEFINITION]: outputFieldDefinition,
      [OutputFieldKeys.UPDATE_TYPE]: UPDATE
    });
  });
};
export const getOutputFieldDefinitionsFromAllActionOutputs = ({
  allOutputsByActionTypeId = {},
  actionTypeId
}) => {
  const outputsForAction = allOutputsByActionTypeId[actionTypeId];
  if (outputsForAction) {
    const outputFieldDefinitionsAsRecords = outputsForAction.map(outputFieldDefinition => {
      return ImmutableMap({
        [OutputFieldKeys.TYPE_DEFINITION]: new OutputTypeDefinition(get(OutputFieldKeys.TYPE_DEFINITION, outputFieldDefinition))
      });
    });
    return List(outputFieldDefinitionsAsRecords);
  } else return List();
};
export const getOutputFieldsFromAllActionOutputs = ({
  allOutputsByActionTypeId = {},
  actionTypeId
}) => {
  const outputsForAction = allOutputsByActionTypeId[actionTypeId];
  if (outputsForAction) {
    const outputFields = _mapOutputFieldDefinitionsToOutputFields(outputsForAction);
    return List(outputFields);
  } else return List();
};
export const getOutputFieldsForActionTypeIdWithDefaults = ({
  actionDefaultOutputs = [],
  actionTypeId,
  allOutputsByActionTypeId = {}
}) => {
  const actionTypeIdOutputFields = getOutputFieldsFromAllActionOutputs({
    actionTypeId,
    allOutputsByActionTypeId
  });
  return actionTypeIdOutputFields.size ? actionTypeIdOutputFields : List(_mapOutputFieldDefinitionsToOutputFields(actionDefaultOutputs));
};